module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/address.b66771c8.svg";